export const BetaFeatures = {
  NEW_HELP_FAQ: 'NEW_HELP_FAQ',
};
